import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=6507d58f&scoped=true"
import script from "./CaseManagement.vue?vue&type=script&lang=js"
export * from "./CaseManagement.vue?vue&type=script&lang=js"
import style0 from "./CaseManagement.vue?vue&type=style&index=0&id=6507d58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507d58f",
  null
  
)

export default component.exports